import React, { useEffect, useRef, useState } from "react";
import { AiPolishField } from "./AiPolishField";
import type { AiSuggestionTarget } from "@/hooks/useAiSuggestionLog";

interface AiPolishTextareaProps extends AiSuggestionTarget {
  /** Startvärde (som defaultValue på en vanlig textarea) */
  defaultValue?: string | null;
  /** Anropas när användaren lämnar fältet eller använder ett AI-förslag */
  onCommit: (value: string) => void;
  label?: string;
  placeholder?: string;
  context?: string;
  rows?: number;
  disabled?: boolean;
  className?: string;
  id?: string;
}

/**
 * Drop-in-ersättare för okontrollerade <Textarea defaultValue onBlur> med
 * AI-hjälp som putsar språket.
 */
export const AiPolishTextarea: React.FC<AiPolishTextareaProps> = ({
  defaultValue,
  onCommit,
  ...rest
}) => {
  const [value, setValue] = useState<string>(defaultValue ?? "");
  const committedRef = useRef<string>(defaultValue ?? "");

  useEffect(() => {
    setValue(defaultValue ?? "");
    committedRef.current = defaultValue ?? "";
  }, [defaultValue]);

  const commit = (next?: string) => {
    const v = next ?? value;
    if (v === committedRef.current) return;
    committedRef.current = v;
    onCommit(v);
  };

  return (
    <AiPolishField
      {...rest}
      value={value}
      onChange={setValue}
      onBlur={(v) => commit(v)}
    />
  );
};

export default AiPolishTextarea;
